import { render, staticRenderFns } from "./per-page.vue?vue&type=template&id=5b47069d&scoped=true&"
import script from "./per-page.vue?vue&type=script&lang=js&"
export * from "./per-page.vue?vue&type=script&lang=js&"
import style0 from "./per-page.vue?vue&type=style&index=0&id=5b47069d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b47069d",
  null
  
)

export default component.exports